import React from "react";
import "../../assets/styles/banner.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination"; 
import { Link } from "react-router-dom";
import { config } from "../config";

const Banner = () => {
  return (
    <Swiper
      modules={[Autoplay]}
      autoplay={{ delay: 3000 }}
      loop={true}
      className="hero-slider"
    >
      <SwiperSlide>
        <div className="slide slide1">
          <div className="bg-overlay"></div>
          <div className="overlay">
            <h1>QUALITY ALUMINIUM FOR A BRIGHTER WORLD</h1>
            <div className="btn-respo">
              <Link to={`${config.appUrl}about-us`} className="explore-more visible">Explore More</Link>
              <Link to={`${config.appUrl}contact-us`} className="scroll-to-top-button visible">Contact Us</Link>
            </div>
          </div>
        </div>
      </SwiperSlide>

      <SwiperSlide>
        <div className="slide slide2">
          <div className="bg-overlay"></div>
          <div className="overlay">
            <h1>QUALITY ALUMINIUM FOR A BRIGHTER WORLD</h1>
            <div className="btn-respo">
              <Link to={`${config.appUrl}about-us`} className="explore-more visible">Explore More</Link>
              <Link to={`${config.appUrl}contact-us`} className="scroll-to-top-button visible">Contact Us</Link>
            </div>
          </div>
        </div>
      </SwiperSlide>

      <SwiperSlide>
        <div className="slide slide3">
          <div className="bg-overlay"></div>
          <div className="overlay">
            <h1>QUALITY ALUMINIUM FOR A BRIGHTER WORLD</h1>
            <div className="btn-respo">
              <Link to={`${config.appUrl}about-us`} className="explore-more visible">Explore More</Link>
              <Link to={`${config.appUrl}contact-us`} className="scroll-to-top-button visible">Contact Us</Link>
            </div>
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
  );
};

export default Banner;